import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-downArrow",
  "use": "icon-downArrow-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol viewBox=\"0 0 8 5\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-downArrow\">\n    <path d=\"M8 0H0L4 5L8 0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol